<div class="card p-4 flex flex-col mt-2">
  <nz-skeleton [ngClass]="loading ? 'p-3':'p-0'" [nzLoading]="loading" [nzActive]="true" [nzParagraph]="false">
    <div class="py-1 font-bold text-lg flex items-center gap-2">
      <button
        class="border-none bg-transparent cursor-pointer flex items-center"
        (click)="back()"
      >
        <img
          src="https://storage.googleapis.com/komerce/assets/icons/back.svg"
          alt=""
          class="w-10"
        />
      </button>
      Choose Package
    </div>
  </nz-skeleton>
  <hr class="my-4 border-t border-gray-200" />
  <nz-skeleton [ngClass]="loading ? 'p-3':'p-0'" [nzLoading]="loading" [nzActive]="true" [nzParagraph]="false">
    <div class="mt-2 flex gap-3">
      <button
        class="rounded px-6 py-2"
        [ngClass]="isPro ? 'actived' : 'non-actived'"
        (click)="switchPro()"
      >
        Pro
      </button>
      <button
        class="rounded px-6 py-2"
        [ngClass]="!isPro ? 'actived' : 'non-actived'"
        (click)="switchEnterprise()"
      >
        Enterprise
      </button>
    </div>
  </nz-skeleton>
  <div class="mt-4 flex gap-4 flex-wrap">
    <div class="w-full lg:w-7/12">
      <nz-radio-group
        [(ngModel)]="selectedPackage"
        (ngModelChange)="handleSelected($event)"
        nzSize="large"
        class="flex flex-col gap-3 w-full"
      >
        <label
          *ngFor="let item of packageList; let i = index"
          nz-radio-button
          [nzValue]="item.id"
          class="w-full h-auto !border-0 bg-transparent"
          [ngClass]="{
            'selected': selectedPackage === item.id,
            'nonselected': selectedPackage !== item.id
          }"
        >
        <nz-skeleton [ngClass]="loading ? 'p-3':'p-0'" [nzLoading]="loading" [nzActive]="true">
          <div class="flex justify-between items-center">
            <div class="flex justify-start items-center gap-3">
              <img
                [src]="
                  item.level_type === 2
                    ? 'https://storage.googleapis.com/komerce/rajaongkir/pro-ro-icon.svg'
                    : 'https://storage.googleapis.com/komerce/rajaongkir/enterprise-ro-icon.svg'
                "
                alt="package"
                class="w-[50px]"
              />
              <div class="flex flex-col text-left">
                <span class="font-bold text-[18px]">{{
                  item.level_type === 2 ? "Pro Package" : "Enterprise Package"
                }}</span>
                <span class="text-gray-500">{{ descName(item.duration) }}</span>
              </div>
            </div>
            <div class="flex justify-end flex-col items-end">
              <span class="font-bold text-[18px]">{{
                item.discounted_price + item.tax | idr
              }}</span>
              <span class="line-through text-gray-400">{{
                item.original_price | idr
              }}</span>
            </div>
          </div>
        </nz-skeleton>
        </label>
      </nz-radio-group>
    </div>

    <nz-card
      *ngIf="cartListData"
      class="flex p-4 w-full lg:w-1/3 flex-grow rounded-xl bg-white border border-[#e5e5e5]"
      [nzBordered]="false"
    >
      <nz-skeleton [ngClass]="loading ? 'p-3':'p-0'" [nzLoading]="loading" [nzActive]="true">
        <span class="font-bold text-[18px]">Purchase Detail</span>

        <div class="mt-4 mb-4 border rounded-lg overflow-hidden border-[#dcfce7] bg-[#f0fdf4]">
          <div class="p-3 flex justify-between items-center bg-white border-gray-300 border rounded-lg">
            <div class="flex flex-col">
              <span class="font-bold text-[15px] text-black">
                {{ cartListData.package.startsWith("Pro") ? "Pro Package" : "Enterprise Package" }}
              </span>
              <span class="text-gray-500 mt-1 text-[13px]">
                {{ handleMonth(selectedPackage) | lowercase }} access
              </span>
            </div>
            <div>
              <span class="rounded-full text-white bg-[#f97316] text-[12px] font-medium py-1.5 px-3.5">
                Selected
              </span>
            </div>
          </div>
          <div *ngIf="cartListData.is_bonus_month_applied" class="p-2 flex items-center gap-2 bg-[#f0fdf4] text-[#16a34a] text-[13px]">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="ml-2">
              <polyline points="20 12 20 22 4 22 4 12"></polyline>
              <rect x="2" y="7" width="20" height="5"></rect>
              <line x1="12" y1="22" x2="12" y2="7"></line>
              <path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"></path>
              <path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"></path>
            </svg>
            <span>+1 month for first-time subscription</span>
          </div>
        </div>

        <div class="flex flex-col gap-3">
          <div class="flex justify-between items-center">
            <span class="text-gray-500 text-[15px]">Active until</span>
            <span class="text-right text-black text-[15px]">{{
              cartListData.active_until ? (cartListData.active_until | date : "dd MMMM yyyy") : "-"
            }}</span>
          </div>
          <div class="flex justify-between items-center">
            <span class="text-gray-500 text-[15px]">Price</span>
            <span class="text-right text-black text-[15px]">{{ cartListData.discount_price | idr }}</span>
          </div>
          <div class="flex justify-between items-center">
            <span class="text-gray-500 text-[15px]">VAT 11%</span>
            <span class="text-right text-black text-[15px]">{{ (cartListData.tax || 0) | idr }}</span>
          </div>
          <div class="flex justify-between items-center">
            <span class="text-gray-500 text-[15px]">Upgrade discount</span>
            <span class="text-right text-black text-[15px]" *ngIf="cartListData.upgrade_discount !== 0">{{
              cartListData.upgrade_discount | idr
            }}</span>
            <span class="text-right text-black text-[15px]" *ngIf="cartListData.upgrade_discount === 0">-</span>
          </div>
        </div>
        <hr class="my-4 border-gray-500" />
        <div class="flex justify-between items-center">
          <span class="font-bold text-[16px]">Total</span>
          <span class="font-bold text-[20px]">{{ cartListData.total | idr }}</span>
        </div>
        <button
          class="w-full mt-4 purchase font-bold h-12 text-[15px] rounded-lg bg-[#ea580c] text-white border-none cursor-pointer disabled:opacity-50"
          [disabled]="greatDisc"
          (click)="handlePurchase(cartListData.total)"
        >
          Purchase Now
        </button>
      </nz-skeleton>
    </nz-card>
  </div>
</div>
